/* eslint-disable */
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { doc, setDoc, addDoc, collection } from "firebase/firestore";
import { db } from "../../../firebase";
import Swal from "sweetalert2";
import OTPVerificationModal from "./OTPVerificationModal";
import {
  Check,
  RefreshCw,
  Lock,
  Info,
  ShoppingCart,
  LayoutDashboard,
} from "lucide-react";
import apicache from "../../clearCach/clear";
import { useTranslation } from "react-i18next";

export default function ActivationDigitalProducts() {
  const store = useSelector((state) => state.StoreReducer);
  const digitalStore = useSelector((state) => state.digitalStoreReducer);
  const account = useSelector((state) => state.AccountReducer);
  const products = useSelector((state) => state.ProductsReducer);
  const [loading, setLoading] = useState(false);
  const [showOTPModal, setShowOTPModal] = useState(false);
  const [isVerified, setIsVerified] = useState(false);
  const { t } = useTranslation();
  const [data, setData] = useState(null);
  const [isNewDocument, setIsNewDocument] = useState(false);

  const onUpdatePhoneNumber = async (phone) => {
    try {
      setDoc(doc(db, "account", account.id), {
        ...account,
        phone: phone,
      });
    } catch (error) {
      console.error("Error updating phone number:", error);
    }
  };

  useEffect(() => {
    if (digitalStore && Object.keys(digitalStore).length > 0) {
      setData(digitalStore);
      setIsNewDocument(false);
    } else {
      const defaultDigitalStore = {
        user: store.user,
        color2: "#ffb43f",
        categories: [
          "كل المنتجات",
          "التصنيف -1-",
          "التصنيف -2-",
          "التصنيف -3-",
          "التصنيف -4-",
          "https://foorweb.net/1-1",
          "https://foorweb.net/2-1.png",
          "https://foorweb.net/3-1.png",
          "https://foorweb.net/4-1.png",
          "https://foorweb.net/5-1.png",
        ],

        googleShit: "",
        color1: store?.color1,
        title: store?.title,
        arabics: true,
        img: store.img,
        logo: store.logo,
        footer: store.footer,
        visits: 0,
        facebookPixel: "",
        SocialMedia: store.SocialMedia,
        texting: store.texting,
        paymentMethods: {
          binance: { enabled: false },
          ccp: { enabled: false },
          dukascopy: { enabled: false },
          paymentLater: { enabled: true },
          paypal: { enabled: false },
          redotpay: { enabled: false },
          slickpay: { enabled: false },
          stripe: { enabled: false },
          wise: { enabled: false },
        },
      };

      setData(defaultDigitalStore);
      setIsNewDocument(true);
    }
  }, [digitalStore, account]);

  const showAlert = (
    icon,
    title,
    text,
    showCancelButton = false,
    confirmButtonText = t("digitalSections.messages.toggle.confirm")
  ) => {
    return Swal.fire({
      icon,
      title,
      text,
      confirmButtonText,
      cancelButtonText: t("digitalSections.form.actions.cancel"),
      showCancelButton,
      confirmButtonColor: "rgb(141, 93, 167)",
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: true,
      backdrop: `
        rgba(0,0,0,0.7)
      `,
      position: "center",
      customClass: {
        popup: "swal-popup-on-top",
        backdrop: "swal-backdrop-on-top",
        container: "swal-container-on-top",
      },
      willOpen: () => {
        document.querySelector(".swal2-container").style.zIndex = "9999999999";
      },
    });
  };

  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `
      .swal-container-on-top {
        z-index: 9999999999 !important;
      }
      .swal-backdrop-on-top {
        background: rgba(0,0,0,0.7) !important;
      }
      .swal-popup-on-top {
        position: relative;
        box-shadow: 0 0 20px rgba(0,0,0,0.2);
      }
      body.swal2-shown {
        overflow: hidden;
      }
      body.swal2-shown > [aria-hidden="true"] {
        filter: blur(3px);
      }
    `;
    document.head.appendChild(style);

    // Add a click handler to ensure modal shows on top
    const handleDocumentClick = () => {
      const swalContainer = document.querySelector(".swal2-container");
      if (swalContainer) {
        swalContainer.style.zIndex = "9999999999";
      }
    };

    document.addEventListener("click", handleDocumentClick);

    return () => {
      document.head.removeChild(style);
      document.removeEventListener("click", handleDocumentClick);
    };
  }, []);

  const handleDChange = () => {
    if (data) {
      setData({
        ...data,
        isActiveDigitalProducts: !data.isActiveDigitalProducts,
        updatedAt: new Date(),
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!data) return;

    try {
      setLoading(true);

      if (!data.isActiveDigitalProducts) {
        if (isNewDocument) {
          setLoading(false);
          return;
        } else {
          await setDoc(doc(db, "digitalStore", data.id), {
            ...data,
            updatedAt: new Date(),
          });
        }

        setLoading(false);
        apicache(account, products);
        await Swal.fire({
          icon: "success",
          title: t(
            "servicePageActivation.digitalProducts.alerts.stopActivation.title"
          ),
          text: t(
            "servicePageActivation.digitalProducts.alerts.stopActivation.text"
          ),
        });
        return;
      }

      // Vérification OTP pour l'activation
      if (!account.isPhoneVerified && !isVerified) {
        setShowOTPModal(true);
        setLoading(false);
        return;
      }

      let documentId;

      if (isNewDocument) {
        const docRef = await addDoc(collection(db, "digitalStore"), {
          ...data,
          updatedAt: new Date(),
        });
        documentId = docRef.id;
        const updatedData = { ...data, id: documentId };
        setData(updatedData);
        setIsNewDocument(false);
      } else {
        documentId = data.id;
        await setDoc(doc(db, "digitalStore", documentId), {
          ...data,
          updatedAt: new Date(),
        });
      }
      await setDoc(doc(db, "account", account.id), {
        ...account,
        isActiveDigitalProducts: data.isActiveDigitalProducts,
      });

      setLoading(false);
      apicache(account, products);

      await Swal.fire({
        icon: "success",
        title: t(
          "servicePageActivation.digitalProducts.alerts.activation.title"
        ),
        text: t("servicePageActivation.digitalProducts.alerts.activation.text"),
      });
    } catch (error) {
      setLoading(false);
      await Swal.fire({
        icon: "error",
        title: t("servicePageActivation.digitalProducts.alerts.error.title"),
        text: t("servicePageActivation.digitalProducts.alerts.error.text"),
      });
      console.error("Error saving Digital Products settings:", error);
    }
  };

  const handlePay = async () => {
    const result = await showAlert(
      "info",
      t("servicePageActivation.digitalProducts.alerts.paidFeature.title"),
      t("servicePageActivation.digitalProducts.alerts.paidFeature.text"),
      true,
      t("servicePageActivation.digitalProducts.alerts.paidFeature.confirm")
    );

    if (result.isConfirmed) {
      window.location.href = "/plan";
    }
  };

  const digitalProductsBenefits = [
    {
      title: t(
        "servicePageActivation.digitalProducts.benefits.items.directSales.title"
      ),
      description: t(
        "servicePageActivation.digitalProducts.benefits.items.directSales.description"
      ),
      icon: <ShoppingCart className="text-[#9e68ba]" size={20} />,
    },
    {
      title: t(
        "servicePageActivation.digitalProducts.benefits.items.autoDelivery.title"
      ),
      description: t(
        "servicePageActivation.digitalProducts.benefits.items.autoDelivery.description"
      ),
      icon: <Check className="text-green-500" size={20} />,
    },
    {
      title: t(
        "servicePageActivation.digitalProducts.benefits.items.contentProtection.title"
      ),
      description: t(
        "servicePageActivation.digitalProducts.benefits.items.contentProtection.description"
      ),
      icon: <Lock className="text-red-500" size={20} />,
    },
  ];

  // Afficher un loader pendant que les données se chargent
  if (data === null) {
    return (
      <div className="min-h-[400px] h-fit p-6 flex items-center justify-center">
        <div className="flex items-center space-x-2">
          <RefreshCw className="animate-spin" size={20} />
          <span className="text-gray-600 dark:text-gray-300">
            {t("paymentMethods.loading")}
          </span>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-[400px] h-fit p-6">
      <div className="bg-white dark:!bg-[#1f1f1f] rounded-xl shadow-sm p-6 border border-[#fbf4ff] dark:!border-[#2d2d2d] transition-colors duration-300">
        <div className="mb-6">
          <h3 className="text-xl font-bold text-[#9e68ba] dark:text-[#b47ddb] mb-2 flex items-center">
            <LayoutDashboard className="ml-2" size={20} />
            {t("servicePageActivation.digitalProducts.header.title")}
          </h3>
          <p className="text-gray-600 dark:text-gray-300 mb-4">
            {t("servicePageActivation.digitalProducts.header.description")}
          </p>

          {/* Info Box */}
          <div className="bg-blue-50 dark:!bg-blue-900/30 rounded-lg border border-blue-200 dark:!border-blue-800 p-4 flex mb-6">
            <Info size={20} className="text-blue-500 ml-2 flex-shrink-0 mt-1" />
            <div>
              <p className="font-medium text-blue-800 dark:text-blue-300 mb-1">
                {t("servicePageActivation.digitalProducts.infoBox.title")}
              </p>
              <p className="text-blue-700 dark:text-blue-400 text-sm">
                {t("servicePageActivation.digitalProducts.infoBox.description")}
              </p>
            </div>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Main Toggle */}
          <div>
            <label className="block text-sm font-medium text-[#9e68ba] dark:text-[#b47ddb] mb-4">
              {t("servicePageActivation.digitalProducts.toggle.label")}
            </label>
            <div
              className={`p-4 rounded-lg border transition-colors cursor-pointer flex items-center ${
                data.isActiveDigitalProducts
                  ? "bg-[#fcf6ff] dark:!bg-[#2a1f2f] border-purple-200 dark:!border-purple-500/40"
                  : "bg-white dark:!bg-[#1f1f1f] border-gray-200 dark:!border-gray-700 hover:bg-gray-50 dark:hover:bg-[#2a2a2a]"
              }`}
              onClick={handleDChange}
            >
              <div className="relative inline-block w-12 ml-3 align-middle select-none">
                <input
                  type="checkbox"
                  checked={data.isActiveDigitalProducts}
                  onChange={() => {}}
                  className="hidden"
                  id="toggle"
                />
                <label
                  htmlFor="toggle"
                  className={`block overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer ${
                    data.isActiveDigitalProducts ? "bg-purple-400" : ""
                  }`}
                >
                  <span
                    className={`block h-6 w-6 rounded-full bg-white shadow transform transition-transform duration-200 ease-in ${
                      data.isActiveDigitalProducts
                        ? "translate-x-6"
                        : "translate-x-0"
                    }`}
                  />
                </label>
              </div>
              <div>
                <p className="font-medium dark:text-gray-200">
                  {data.isActiveDigitalProducts
                    ? t(
                        "servicePageActivation.digitalProducts.toggle.active.title"
                      )
                    : t(
                        "servicePageActivation.digitalProducts.toggle.inactive.title"
                      )}
                </p>
                <p className="text-sm text-gray-500 dark:text-gray-400">
                  {data.isActiveDigitalProducts
                    ? t(
                        "servicePageActivation.digitalProducts.toggle.active.description"
                      )
                    : t(
                        "servicePageActivation.digitalProducts.toggle.inactive.description"
                      )}
                </p>
              </div>
            </div>
          </div>

          {/* Feature Highlights */}
          {data.isActiveDigitalProducts && (
            <div className="space-y-4 mt-6">
              <h4 className="font-medium text-[#9e68ba] dark:text-[#b47ddb]">
                {t("servicePageActivation.digitalProducts.benefits.title")}
              </h4>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                {digitalProductsBenefits.map((benefit, index) => (
                  <div
                    key={index}
                    className="bg-white dark:!bg-[#2a2a2a] rounded-lg p-4 border border-gray-200 dark:!border-gray-700 shadow-sm"
                  >
                    <div className="flex items-center mb-2">
                      {benefit.icon}
                      <h5 className="font-medium text-gray-800 dark:text-gray-200 mr-2 text-sm">
                        {benefit.title}
                      </h5>
                    </div>
                    <p className="text-xs text-gray-600 dark:text-gray-400">
                      {benefit.description}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Tips Section */}
          <div className="bg-yellow-50 dark:!bg-yellow-900/30 p-4 rounded-lg border border-yellow-100 dark:!border-yellow-700">
            <h4 className="font-medium text-lg text-yellow-800 dark:text-yellow-300 mb-2 flex items-center">
              <Info size={18} className="ml-2" />
              {t("servicePageActivation.digitalProducts.tips.title")}
            </h4>
            <ul className="text-sm text-gray-700 dark:text-gray-300 space-y-2 mr-5 list-disc">
              <li>{t("servicePageActivation.digitalProducts.tips.list.0")}</li>
              <li>{t("servicePageActivation.digitalProducts.tips.list.1")}</li>
              <li>{t("servicePageActivation.digitalProducts.tips.list.2")}</li>
              <li>{t("servicePageActivation.digitalProducts.tips.list.3")}</li>
            </ul>
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            disabled={loading}
            className={`px-6 py-3 bg-[#9b59bf] hover:bg-[#814a9f] text-white rounded-lg transition-colors flex items-center ${
              loading ? "opacity-70 cursor-not-allowed" : ""
            }`}
          >
            {loading ? (
              <>
                <RefreshCw className="animate-spin ml-2" size={18} />
                {t("servicePageActivation.digitalProducts.saveButton.saving")}
              </>
            ) : (
              <>
                <Check className="ml-2" size={18} />
                {t("servicePageActivation.digitalProducts.saveButton.save")}
              </>
            )}
          </button>
        </form>
      </div>

      <OTPVerificationModal
        isOpen={showOTPModal}
        isVerified={isVerified}
        setIsVerified={setIsVerified}
        onClose={async (isVerified) => {
          setShowOTPModal(false);
          if (isVerified) {
            // Reprendre la logique de sauvegarde après vérification OTP
            const fakeEvent = { preventDefault: () => {} };
            await handleSubmit(fakeEvent);
          }
        }}
        phone={account.phone}
        onUpdatePhoneNumber={onUpdatePhoneNumber}
      />
    </div>
  );
}
